import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Showcase from 'Catalog/Showcase'
import { Icon } from 'loyal-react'
import '@loyal_template/notfound.css'

const NotFound = ({ isSearch }) => {
  return (
    <div className='container not-found py-3'>
      <div
        className={`box-notfound row my-4 mt-md-0 py-3 px-3 mx-1 bg-white radius border border-color-ui-3`}
      >
        <div className='col-12 col-sm-auto'>
          <div className='row'>
            <div className='col-auto mx-auto'>
              <div className='bg-ui-4 radius-circle px-3 py-3'>
                <Icon
                  className='txt-headline color-brand-1'
                  iconName='icon_loupe'
                />
              </div>
            </div>
          </div>
        </div>
        <div className='col-12 col-sm mt-2'>
          <h3 className='txt-left mb-1'>
            Opps! Não foi encontrado nenhum resultado para sua busca.
          </h3>
          <p className='txt-left txt-body-sm'>
            &middot; Verifique se os termos digitados estão corretos.
          </p>
          <p className='txt-left txt-body-sm'>
            &middot; Tente utilizar palavras genéricas e refinar a busca nos
            filtros laterais.
          </p>
        </div>
      </div>
      {isSearch && (
        <Fragment>
          <Showcase showcaseType='5' identifier='home' />
          <Showcase showcaseType='7' identifier='home' />
        </Fragment>
      )}
    </div>
  )
}

NotFound.propTypes = {
  isSearch: PropTypes.bool
}

NotFound.defaultProps = {
  isSearch: false
}

export default NotFound



// WEBPACK FOOTER //
// ./src/Catalog/Search/NotFound.js